import { baseGet } from "@/utils/api/base";
import apiEndPointList from "../constant/apiEndPointsList";


const sublinkServices = {
    getParentGroupBySublink: async ({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }: { id_path: string, language: string, page: string, limit: string, version_id: string, scene_name?: string, sublink: string, show_children_groups?: string }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_PARENT_GROUP_BY_SUBLINK({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },

    getParentGroupBySublinkForHomeScreen: async ({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }: { id_path: string, language: string, page: string, limit: string, version_id: string, scene_name?: string, sublink: string, show_children_groups?: string }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_PARENT_GROUP_BY_SUBLINK_FOR_HOME_SCREEN({ id_path, language, page, limit, version_id, scene_name, sublink, show_children_groups }),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },

    getNextSceneSublink: async (id_path, sublink, { sceneName, lang = 'vn' }: { sceneName: string, lang?: string }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_NEXT_SCENE_BY_SCENE_NAME_SUBLINK(sceneName, id_path, lang, sublink),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },

    getPreviousSceneSublink: async (id_path, sublink, { sceneName, lang = 'vn' }: { sceneName: string, lang?: string }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_PREVIOUS_SCENE_BY_SCENE_NAME_SUBLINK(sceneName, id_path, lang, sublink),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },
    getHotspotsBySceneNameSublink: async (sceneName: string, idPath: string, locale: string, sublink: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_HOTSPOTS_BY_SCENE_NAME_SUBLINK(sceneName, idPath, locale, sublink),
                // headers: {
                //     'access-token': `${accessToken}`    
                // }, 
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },
    getNestedCategoriesSublink: async (type_id: any, idPath?: string, language_id?: string, sublink?: string, includeAssets = false) => {
        let response: any = null;
        try {
            // const headers = {
            //     'x-api-key': `${API_TOKEN}`
            // };

            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_NESTED_CATEGORIES_WITH_SUBLINK(idPath, type_id, sublink, language_id),
            });
        } catch (err) {
            response = err;
        }
        const result = response?.data;
        if (!includeAssets || !result?.success || !Array.isArray(result.data)) return result;

        // The sublink tree contains counts, but does not embed category assets.
        // Hydrate direct assets so folder grouping stays correct without duplicating descendants.
        const hydrateCategory = async (category: any): Promise<any> => {
            let assets = Array.isArray(category.assets) ? category.assets : null;
            if (assets === null) {
                assets = [];
                const limit = 50;
                for (let page = 1; ; page += 1) {
                    const endpoint = apiEndPointList.sublink.GET_ASSET_BY_CATEGORY_WITH_SUBLINK(
                        category.category_uuid, idPath, sublink, limit, page,
                    );
                    const response = await baseGet<{ success: boolean; data: any[]; pagination?: { totalPages?: number } }>({
                        endpoint: `${endpoint}&language_id=${encodeURIComponent(language_id || 'vn')}`,
                    });
                    const body = response?.data;
                    if (!body?.success || !Array.isArray(body.data)) {
                        throw new Error('Unable to load sublink category assets');
                    }
                    // Category endpoints can contain several asset types; paging still
                    // follows the unfiltered response so later matching assets are retained.
                    assets.push(...body.data.filter(asset => Number(asset.asset_type_id) === Number(type_id)));
                    const totalPages = body.pagination?.totalPages;
                    if (body.data.length < limit || (totalPages != null && page >= totalPages)) break;
                }
            }
            const children = [];
            for (const child of category.children || []) children.push(await hydrateCategory(child));
            return { ...category, assets, children };
        };
        const categories = [];
        for (const category of result.data) categories.push(await hydrateCategory(category));
        return { ...result, data: categories };
    },
    getAssetByCategoryWithSublink: async (category_uuid: string, idPath: string, sublink: string, limit?: number, page?: number) => {
        // console.log("category_id", category_id);
        // console.log("limit", limit);
        // console.log("page", page);
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_ASSET_BY_CATEGORY_WITH_SUBLINK(category_uuid, idPath, sublink, limit, page),
            });
        } catch (err) {
            response = err;
        }
        return response.data;
    },
    getAllAutotoursWithSublink: async (id_path: string, sublink: string, language_id: string, page?: string, limit?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_ALL_AUTOTOURS_WITH_SUBLINK(id_path, sublink, language_id, page, limit),
            });

        } catch (error) {
            console.error("Error fetching autotours:", error);
            response = error;
        }
        return response.data;
    },

    getAllSublinks: async ({ id_path, page, limit, search, sort, order }: { id_path: string, page?: number, limit?: number, search?: string, sort?: string, order?: string }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.sublink.GET_ALL_SUBLINKS({ id_path, page, limit, search, sort, order }),
            });
        } catch (err) {
            response = err;
        }
        return response?.data;
    },

}

export default sublinkServices;
